var Control = {
  props: {
    position: {
      type: String,
      default: 'topright'
    }
  },
  mounted: function mounted () {
    this.controlOptions = {
      position: this.position
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  }
};

export default Control;



//////////////////
// WEBPACK FOOTER
// ./~/vue2-leaflet/dist/mixins/Control.js
// module id = 1695
// module chunks = 1